/* eslint-disable */
import { T, useTheme } from "../../../tokens";
import { Row, Box } from "../../../shared/WireframePrimitives";
import ResponsiveShell from "../../../shared/ResponsiveShell";
import { PRODUCT_FOOTER } from "../../../shared/layoutTokens";

const ADMIN_NAV_ITEMS = [
  ["📊", "Dashboard"],
  ["🏪", "My Hub"],
  ["🖼️", "Media Gallery"],
  ["📓", "Pocket Diary"],
  ["👥", "Staff Manage..."],
  ["💳", "Subscription"],
  ["⚙️", "Hub Settings"],
  ["🕒", "Log"],
];

export function AdminSidebar({ dark, active = "Dashboard", collapsed = false }) {
  const th = useTheme(dark);
  const sidebarWidth = collapsed ? 56 : 150;

  return (
    <div
      style={{
        width: sidebarWidth,
        flexShrink: 0,
        alignSelf: "stretch",
        background: th.sidebar,
        borderRight: `1px solid ${th.border}`,
        padding: "10px 0",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          padding: collapsed ? "6px 8px 10px" : "6px 12px 10px",
          justifyContent: collapsed ? "center" : "flex-start",
        }}
      >
        <div
          style={{
            width: 20,
            height: 20,
            borderRadius: 6,
            background: T.brand,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 10,
            fontWeight: 700,
            color: "#fff",
          }}
        >
          Z
        </div>
        {!collapsed && <span style={{ fontSize: 11, fontWeight: 600, color: th.text }}>ZiniHub</span>}
      </div>
      {ADMIN_NAV_ITEMS.map(([icon, label]) => {
        const isActive = label === active;
        return (
          <div
            key={label}
            title={collapsed ? label : undefined}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: collapsed ? "5px 8px" : "5px 12px",
              fontSize: 10,
              justifyContent: collapsed ? "center" : "flex-start",
              background: isActive ? T.brandSoft : "none",
              borderLeft: isActive ? `2px solid ${T.brand}` : "2px solid transparent",
              color: isActive ? T.brand : th.textSec,
              fontWeight: isActive ? "500" : "400",
              transition: th.tr,
              cursor: "default",
            }}
          >
            <span style={{ fontSize: 11 }}>{icon}</span>
            {!collapsed && <span>{label}</span>}
          </div>
        );
      })}
      <div
        style={{
          marginTop: "auto",
          padding: collapsed ? "6px 8px" : "6px 12px",
          display: "flex",
          alignItems: "center",
          gap: 6,
          fontSize: 10,
          color: T.red,
          cursor: "default",
          justifyContent: collapsed ? "center" : "flex-start",
        }}
      >
        <span>⏻</span>
        {!collapsed && <span>Logout</span>}
      </div>
    </div>
  );
}

export function AdminTopbar({ dark, page }) {
  const th = useTheme(dark);
  return (
    <div
      style={{
        height: 44,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 14px",
        borderBottom: `1px solid ${th.border}`,
        background: dark ? "rgba(17,19,24,0.95)" : "rgba(255,255,255,0.95)",
        flexShrink: 0,
      }}
    >
      <Row gap={8}>
        <Box w={14} h={9} r={2} bg="rgba(128,128,128,0.2)" />
        <span style={{ fontSize: 10, color: "rgba(128,128,128,0.35)" }}>User</span>
        <span style={{ fontSize: 10, color: "rgba(128,128,128,0.25)" }}>›</span>
        <span style={{ fontSize: 10, color: "rgba(128,128,128,0.6)", fontWeight: "500" }}>{page}</span>
      </Row>
      <Row gap={6}>
        <div
          style={{
            height: 24,
            padding: "0 8px",
            background: "rgba(128,128,128,0.08)",
            borderRadius: 5,
            border: "1px solid rgba(128,128,128,0.12)",
            display: "flex",
            alignItems: "center",
            gap: 4,
            fontSize: 10,
            color: "rgba(128,128,128,0.55)",
          }}
        >
          Hub22 <span style={{ fontSize: 8 }}>▾</span>
        </div>
        <div
          style={{
            width: 24,
            height: 24,
            borderRadius: "50%",
            background: T.brandSoft,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 11,
          }}
        >
          🔔
        </div>
        <div
          style={{
            width: 24,
            height: 24,
            borderRadius: "50%",
            background: "rgba(128,128,128,0.12)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 11,
          }}
        >
          👤
        </div>
      </Row>
    </div>
  );
}

export function AdminFooter({ dark }) {
  const th = useTheme(dark);
  return (
    <div
      style={{
        height: 32,
        borderTop: `1px solid ${th.border}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 9,
        color: th.textMuted,
        background: th.surface,
        flexShrink: 0,
      }}
    >
      {PRODUCT_FOOTER[0]}{' '}<span style={{color:T.brand}}>{PRODUCT_FOOTER[1]}</span>
    </div>
  );
}

/** AppShell layout with ResponsiveShell — mobile drawer closed by default. */
export function AdminAppShell({ dark, viewport = "desktop", active = "Dashboard", pageTitle, children }) {
  const title = pageTitle || active;

  return (
    <div style={{ flex: 1, minHeight: 0, height: "100%", display: "flex", flexDirection: "column" }}>
      <ResponsiveShell
        dark={dark}
        viewport={viewport}
        pageTitle={title}
        topbar={<AdminTopbar dark={dark} page={title} />}
        footer={<AdminFooter dark={dark} />}
        sidebar={({ collapsed }) => <AdminSidebar dark={dark} active={active} collapsed={collapsed} />}
      >
        <div style={{ flex: 1, minWidth: 0, minHeight: 0, display: "flex", flexDirection: "column" }}>{children}</div>
      </ResponsiveShell>
    </div>
  );
}

export { CustAppShell, CustFooter, CustSidebar, CustTopbar } from "./custWireframeShells";
